<template>
  <div class="page">
    <van-form class="form" @submit="onSubmit">
      <van-field
        v-model.trim="form.phone"
        class="field"
        type="tel"
        maxlength="11"
        placeholder="手机号码"
        :left-icon="phoneIcon"
      />

      <van-field
        v-model.trim="form.captchaCode"
        class="field"
        type="tel"
        maxlength="6"
        placeholder="验证码"
        :left-icon="codeIcon"
      >
        <template #button>
          <span class="divider"></span>
          <span v-if="!timer" class="code-btn" @click.stop="getCode"
            >获取验证码</span
          >
          <van-count-down
            v-else
            :time="timer"
            class="code-btn"
            @finish="timer = 0"
          >
            <template #default="timeData">
              {{ timeData.seconds }}s后重发
            </template>
          </van-count-down>
        </template>
      </van-field>

      <div class="submit" @click="onSubmit">验证获奖资格</div>
    </van-form>

    <!-- 特定提示弹框（如 2403 非受邀用户） -->
    <tip-dialog
      :visible="tipVisible"
      :message="tipMsg"
      @close="tipVisible = false"
    />
  </div>
</template>

<script>
import { getCaptcha, login, setToken, getToken } from '@/api/erkeAiStore'
import TipDialog from './TipDialog.vue'

export default {
  name: 'ErkeAiStoreLogin',
  components: { TipDialog },
  data() {
    return {
      phoneIcon: require('@/assets/img/erkeAiStore/login-icon-phone.png'),
      codeIcon: require('@/assets/img/erkeAiStore/login-icon-code.png'),
      form: {
        phone: '',
        captchaCode: ''
      },
      timer: 0,
      loading: false,
      codeLoading: false,
      tipVisible: false,
      tipMsg: ''
    }
  },
  created() {
    this.getBizType()
    // 已登录直接进入
    if (getToken()) {
      this.$router.push({ name: 'erkeAiStoreAward' })
    }
  },
  methods: {
    // bizType 活动编号
    getBizType() {
      const { bizType } = this.$route.query
      if (!bizType) {
        this.$toast.fail('请携带活动参数')
        return ''
      }
      return bizType
    },
    async getCode() {
      const reg = /^1\d{10}$/
      if (!reg.test(this.form.phone)) {
        this.$toast.fail('请填写正确的手机号')
        return
      }
      const bizType = this.getBizType()
      if (!bizType) return
      if (this.codeLoading || this.timer) return
      try {
        this.codeLoading = true
        const res = await getCaptcha({
          phone: this.form.phone,
          bizType
        })
        this.codeLoading = false
        if (res.code === 0) {
          this.timer = 60000
          this.$toast.success('验证码已发送')
        }
      } catch (e) {
        this.codeLoading = false
        const res = (e && e.data) || {}
        if (res.code === 2403) {
          this.tipMsg = '非常抱歉，您不是本次活动的受邀用户！'
          this.tipVisible = true
        } else {
          this.$toast.fail(res.message || '获取验证码失败')
        }
      }
    },
    async onSubmit() {
      const { phone, captchaCode } = this.form
      const phoneReg = /^1\d{10}$/
      const codeReg = /^\d{6}$/
      if (!phoneReg.test(phone)) {
        this.$toast.fail('请填写正确的手机号')
        return
      }
      if (!codeReg.test(captchaCode)) {
        this.$toast.fail('请填写6位验证码')
        return
      }
      const bizType = this.getBizType()
      if (!bizType) return
      if (this.loading) return
      try {
        this.loading = true
        const { code, data } = await login({
          phone,
          captchaCode,
          bizType
        })
        this.loading = false
        if (code === 0) {
          setToken(data)
          this.$router.push({ name: 'erkeAiStoreAward' })
        }
      } catch (e) {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  min-height: 100vh;
  background: #e93506 url('~@/assets/img/erkeAiStore/login-bg(1).png') top
    center no-repeat;
  background-size: 100% auto;
}

.form {
  padding: 131% 10% 40px;

  .field {
    background: #fff;
    border-radius: 26px;
    height: 52px;
    padding: 0 20px;
    margin-bottom: 18px;
    align-items: center;

    &::after {
      border: none;
    }

    :deep(.van-field__left-icon) {
      margin-right: 12px;
      display: flex;
      align-items: center;

      img {
        width: 25px;
        height: 25px;
      }
    }

    :deep(.van-field__control) {
      font-size: 16px;
      color: #212224;
    }

    :deep(.van-field__control::placeholder) {
      color: #808080;
    }

    :deep(.van-field__button) {
      display: flex;
      align-items: center;
    }

    .divider {
      width: 1px;
      height: 18px;
      background: #feddd5;
      margin: 0 12px;
    }

    .code-btn {
      font-size: 16px;
      font-weight: 600;
      color: #e93506;
      white-space: nowrap;
    }
  }

  .submit {
    width: 100%;
    height: 70px;
    margin-top: 28px;
    background: url('~@/assets/img/erkeAiStore/login-btn.png') center / contain
      no-repeat;
    font-size: 20px;
    font-weight: 600;
    color: #fff;
    text-align: center;
    line-height: 70px;
    padding-right: 36px;
    box-sizing: border-box;
  }
}
</style>
